import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../../i18n/LanguageContext';
import { LanguageSwitcher } from '../../../i18n/LanguageSwitcher';
import { commonDict } from '../../../i18n/dictionaries/common';
import styles from './SiteHeader.module.css';

type SiteHeaderProps = {
  /** `overlay` floats transparently over a hero; `solid` sits in normal flow. */
  readonly variant?: 'overlay' | 'solid';
  /** `dark` = dark text (light background); `light` = white text (dark hero). */
  readonly tone?: 'dark' | 'light';
};

export const SiteHeader = ({
  variant = 'solid',
  tone = 'dark',
}: SiteHeaderProps): JSX.Element => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { lang } = useLang();
  const navItems = commonDict[lang].nav;

  const className = [
    styles.header,
    variant === 'overlay' ? styles.overlay : '',
    tone === 'light' ? styles.light : '',
    menuOpen ? styles.menuOpen : '',
  ]
    .filter(Boolean)
    .join(' ');

  const closeMenu = (): void => setMenuOpen(false);

  return (
    <header className={className}>
      <div className={styles.bar}>
        <Link to="/" className={styles.brand} onClick={closeMenu}>
          C.J INVESTMENT CO.,LTD
        </Link>
        <button
          type="button"
          className={styles.toggle}
          aria-label="メニュー"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className={styles.toggleBar} />
          <span className={styles.toggleBar} />
          <span className={styles.toggleBar} />
        </button>
      </div>
      <nav className={styles.nav}>
        {navItems.map((item) =>
          item.to ? (
            <Link
              key={item.to}
              to={item.to}
              className={styles.navLink}
              onClick={closeMenu}
            >
              {item.label}
            </Link>
          ) : (
            <a
              key={item.href ?? item.label}
              href={item.href ?? '#'}
              className={styles.navLink}
              onClick={closeMenu}
            >
              {item.label}
            </a>
          ),
        )}
        <div className={styles.lang}>
          <LanguageSwitcher />
        </div>
      </nav>
    </header>
  );
};
